// OVRA — Simple, reliable cart item remove handler
// No custom elements, no ambiguity. Plain delegated click listener.
(function () {
  function getSectionsToUpdate() {
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function removeItem(key, btn) {
    if (!key) return;
    btn.disabled = true;
    btn.style.opacity = '0.4';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0, sections: getSectionsToUpdate() })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        // Re-render cart drawer section with updated HTML
        if (data.sections && data.sections['cart-drawer']) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
          var newDrawer = doc.querySelector('cart-drawer');
          var oldDrawer = document.querySelector('cart-drawer');
          if (newDrawer && oldDrawer) {
            oldDrawer.innerHTML = newDrawer.innerHTML;
            // Re-open if it was open
            oldDrawer.classList.add('active');
          }
        }
        // Update cart bubble count
        if (data.sections && data.sections['cart-icon-bubble']) {
          var bubbleParser = new DOMParser();
          var bubbleDoc = bubbleParser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          var newBubble = bubbleDoc.querySelector('.shopify-section') || bubbleDoc.body.firstElementChild;
          var oldBubbleWrap = document.getElementById('cart-icon-bubble');
          if (newBubble && oldBubbleWrap) {
            oldBubbleWrap.innerHTML = newBubble.innerHTML;
          }
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
      })
      .catch(function (err) {
        console.error('OVRA remove item failed:', err);
        btn.disabled = false;
        btn.style.opacity = '1';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ovra-remove-btn');
    if (!btn) return;
    e.preventDefault();
    var key = btn.getAttribute('data-ovra-remove-key');
    removeItem(key, btn);
  });
})();
